import React from 'react';
import Text from '../Shared/Text';

const instantVoiceClonesFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <Text key={pkg.code} text={pkg?.maxInstantVoiceCloning} />
  ));

export default instantVoiceClonesFeatures;
